module.exports = __webpack_public_path__ + "static/media/background_input_username.6613cb2c.png";